import React from 'react';
import { RequestIdTableCell } from '../../components/utilities/Table/RequestIdTableCell';
import AmountGeneralRequest from '../../components/utilities/Table/generalColumns/AmountGeneralRequest';

const requestsListStatusEmployees = [
    {
        id: 'bolsa_general_desembolso',
        label: 'BOLSA GENERAL',
        status: 7,
        responsable: false,
        columns: [
            {
                Header: () => 'Crédito',
                id: 'id',
                typeId: 'HeaderRequest',
                Cell: ({ row }) => {
                    return (
                        <RequestIdTableCell
                            row={row}
                            comparativeDateField={'created_at'}
                        />
                    );
                },
            },
            {
                Header: 'Fecha Creación',
                accessor: 'created_at',
            },
            {
                Header: 'Producto',
                accessor: 'empleado_credito_producto.label',
            },
            {
                Header: 'Identificación',
                accessor: 'persona.numero_identificacion',
            },
            {
                Header: 'Cliente',
                accessor: 'persona.full_name',
                Footer: 'Cliente',
                typeId: 'HeaderClient',
            },
            AmountGeneralRequest({
                id: 'monto_apro',
                Header: 'Monto',
                accessor: 'monto_aprobado',
            }),
            {
                Header: 'Estado',
                accessor: 'estado_credito.label',
            },
            {
                Header: 'Usuario',
                accessor: 'usuario_creacion.name',
            },
        ],
        buttonAction: [{ name: 'takeRequest' }],
    },
    {
        id: 'por_completar_gestion_humana',
        label: 'POR COMPLETAR',
        status: '7',
        responsable: true,
        columns: [
            {
                Header: () => 'Crédito',
                id: 'id',
                typeId: 'HeaderRequest',
                Cell: ({ row }) => {
                    return (
                        <RequestIdTableCell
                            row={row}
                            comparativeDateField={'created_at'}
                        />
                    );
                },
            },
            {
                Header: 'Fecha Creación',
                accessor: 'created_at',
            },
            {
                Header: 'Producto',
                accessor: 'empleado_credito_producto.label',
            },
            {
                Header: 'Identificación',
                accessor: 'persona.numero_identificacion',
            },
            {
                Header: 'Cliente',
                accessor: 'persona.full_name',
                Footer: 'Cliente',
                typeId: 'HeaderClient',
            },
            AmountGeneralRequest({
                id: 'monto_apro',
                Header: 'Monto',
                accessor: 'monto_aprobado',
            }),
            {
                Header: 'Estado',
                accessor: 'estado_credito.label',
            },
            {
                Header: 'Usuario',
                accessor: 'usuario_creacion.name',
            },
        ],
    },
    {
        id: 'procesadas_gestion_humana',
        label: 'PROCESADAS',
        // status: '80,60,90',
        responsable: false,
        nameColumnProcessed: [
            {
                name: 'usuario_creacion',
                value: 'user',
                operator: '%26',
            },
            {
                name: 'usuario_desistimiento',
                value: 'user',
                operator: '|',
            },
            {
                name: 'estado_credito',
                value: 60,
                operator: '|',
            },
            {
                name: 'estado_credito',
                value: 90,
                operator: '|',
            },
        ],
        columns: [
            {
                Header: () => 'Crédito',
                id: 'id',
                typeId: 'HeaderRequest',
                Cell: ({ row }) => {
                    return (
                        <RequestIdTableCell
                            row={row}
                            comparativeDateField={'created_at'}
                        />
                    );
                },
            },
            {
                Header: 'Fecha Creación',
                accessor: 'created_at',
            },
            {
                Header: 'Producto',
                accessor: 'empleado_credito_producto.label',
            },
            {
                Header: 'Identificación',
                accessor: 'persona.numero_identificacion',
            },
            {
                Header: 'Cliente',
                accessor: 'persona.full_name',
                Footer: 'Cliente',
                typeId: 'HeaderClient',
            },
            AmountGeneralRequest({
                id: 'monto_aprobado',
                Header: 'Monto',
                accessor: 'monto_aprobado',
            }),
            {
                Header: 'Estado',
                accessor: 'estado_credito.label',
            },
            {
                Header: 'Usuario',
                accessor: 'usuario_creacion.name',
            },
        ],
        buttonAction: [{ name: 'resumeStatusRequest' }],
    },
];

export default requestsListStatusEmployees;
